/**
 * com.remedirx.apps.MyRemedi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { APISubmitResult } from '../model/aPISubmitResult';
import { AdminUserListingResultAdminUserList } from '../model/adminUserListingResultAdminUserList';
import { ApiRequestDto } from '../model/apiRequestDto';
import { OrgUnitModel } from '../model/orgUnitModel';
import { PagedResultsAdminUserList } from '../model/pagedResultsAdminUserList';
import { User } from '../model/user';
import { UserSettings } from '../model/userSettings';
import { UserTimeZone } from '../model/userTimeZone';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class UserService {

    protected basePath = 'http://localhost:3402';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * To add new User with all their notification settings rules.
     * This call takes in UserSettings objects that has all the user and its settings data from UI        Sample Call      http://URL/api/User/AddUser
     * @param settings Current Password of the User. Encrypted by UI
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userAddUser(settings: UserSettings, observe?: 'body', reportProgress?: boolean): Observable<APISubmitResult>;
    public userAddUser(settings: UserSettings, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<APISubmitResult>>;
    public userAddUser(settings: UserSettings, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<APISubmitResult>>;
    public userAddUser(settings: UserSettings, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (settings === null || settings === undefined) {
            throw new Error('Required parameter settings was null or undefined when calling userAddUser.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded',
            'application/hal+json',
            'application/hal+xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<APISubmitResult>(`${this.basePath}/api/User/AddUser`,
            settings,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Change password for the user.
     * This call takes in password string that has been encrypted from UI.         Sample Call      http://URL/api/User/ChangePassword?currentPassword&#x3D;samplePassword&amp;amp;newPassword&#x3D;sampleNewPassword&amp;amp;confirmPassword&#x3D;sampleNewPassword
     * @param currentPassword Current Password of the User. Encrypted by UI
     * @param newPassword New Password entered by the User. Encrypted by UI
     * @param confirmPassword Confirm Password entered by the User. Encrypted by UI
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userChangePassword(currentPassword: string, newPassword: string, confirmPassword: string, observe?: 'body', reportProgress?: boolean): Observable<APISubmitResult>;
    public userChangePassword(currentPassword: string, newPassword: string, confirmPassword: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<APISubmitResult>>;
    public userChangePassword(currentPassword: string, newPassword: string, confirmPassword: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<APISubmitResult>>;
    public userChangePassword(currentPassword: string, newPassword: string, confirmPassword: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (currentPassword === null || currentPassword === undefined) {
            throw new Error('Required parameter currentPassword was null or undefined when calling userChangePassword.');
        }

        if (newPassword === null || newPassword === undefined) {
            throw new Error('Required parameter newPassword was null or undefined when calling userChangePassword.');
        }

        if (confirmPassword === null || confirmPassword === undefined) {
            throw new Error('Required parameter confirmPassword was null or undefined when calling userChangePassword.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (currentPassword !== undefined && currentPassword !== null) {
            queryParameters = queryParameters.set('currentPassword', <any>currentPassword);
        }
        if (newPassword !== undefined && newPassword !== null) {
            queryParameters = queryParameters.set('newPassword', <any>newPassword);
        }
        if (confirmPassword !== undefined && confirmPassword !== null) {
            queryParameters = queryParameters.set('confirmPassword', <any>confirmPassword);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.post<APISubmitResult>(`${this.basePath}/api/User/ChangePassword`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Change a user active atatus
     * Takes in a string parameter of the Username  This call only works if a valid JSON Web Token (JWT) is passed along with the request.
     * @param targetUsername Username of the user to be deactivated
     * @param isActive Sets the user status to active if true, inactive if false
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userChangeUserActiveStatus(targetUsername: string, isActive: boolean, observe?: 'body', reportProgress?: boolean): Observable<APISubmitResult>;
    public userChangeUserActiveStatus(targetUsername: string, isActive: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<APISubmitResult>>;
    public userChangeUserActiveStatus(targetUsername: string, isActive: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<APISubmitResult>>;
    public userChangeUserActiveStatus(targetUsername: string, isActive: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (targetUsername === null || targetUsername === undefined) {
            throw new Error('Required parameter targetUsername was null or undefined when calling userChangeUserActiveStatus.');
        }

        if (isActive === null || isActive === undefined) {
            throw new Error('Required parameter isActive was null or undefined when calling userChangeUserActiveStatus.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (targetUsername !== undefined && targetUsername !== null) {
            queryParameters = queryParameters.set('targetUsername', <any>targetUsername);
        }
        if (isActive !== undefined && isActive !== null) {
            queryParameters = queryParameters.set('isActive', <any>isActive);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.post<APISubmitResult>(`${this.basePath}/api/User/ChangeUserActiveStatus`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param userName 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userCheckDuplicateUsername(userName: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public userCheckDuplicateUsername(userName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public userCheckDuplicateUsername(userName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public userCheckDuplicateUsername(userName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userName === null || userName === undefined) {
            throw new Error('Required parameter userName was null or undefined when calling userCheckDuplicateUsername.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (userName !== undefined && userName !== null) {
            queryParameters = queryParameters.set('userName', <any>userName);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.post<string>(`${this.basePath}/api/User/CheckDuplicateUsername`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userConfirmNumber(observe?: 'body', reportProgress?: boolean): Observable<APISubmitResult>;
    public userConfirmNumber(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<APISubmitResult>>;
    public userConfirmNumber(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<APISubmitResult>>;
    public userConfirmNumber(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<APISubmitResult>(`${this.basePath}/api/User/ConfirmNumber`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * To Edit User settings.  Impersonation is denied on this endpoint.
     * This call takes in UserSettings objects that has all the user and its settings data from UI  This is not allowed in Demo Mode.      Sample Call      http://URL/api/User/EditUser
     * @param settings Current UserSettings of the User. Encrypted by UI
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userEditUser(settings: UserSettings, observe?: 'body', reportProgress?: boolean): Observable<APISubmitResult>;
    public userEditUser(settings: UserSettings, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<APISubmitResult>>;
    public userEditUser(settings: UserSettings, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<APISubmitResult>>;
    public userEditUser(settings: UserSettings, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (settings === null || settings === undefined) {
            throw new Error('Required parameter settings was null or undefined when calling userEditUser.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded',
            'application/hal+json',
            'application/hal+xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<APISubmitResult>(`${this.basePath}/api/User/EditUser`,
            settings,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * To Edit User settings.  Impersonation is allowed on this endpoint.
     * This call takes in UserSettings objects that has all the user and its settings data from UI  This is not allowed in Demo Mode.      Sample Call      http://URL/api/User/EditUserAllowImpersonation
     * @param settings Current UserSettings of the User. Encrypted by UI
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userEditUserAllowImpersonation(settings: UserSettings, observe?: 'body', reportProgress?: boolean): Observable<APISubmitResult>;
    public userEditUserAllowImpersonation(settings: UserSettings, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<APISubmitResult>>;
    public userEditUserAllowImpersonation(settings: UserSettings, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<APISubmitResult>>;
    public userEditUserAllowImpersonation(settings: UserSettings, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (settings === null || settings === undefined) {
            throw new Error('Required parameter settings was null or undefined when calling userEditUserAllowImpersonation.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded',
            'application/hal+json',
            'application/hal+xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<APISubmitResult>(`${this.basePath}/api/User/EditUserAllowImpersonation`,
            settings,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns the list of TimeZones suported currently by My Remedi
     * This call only works if a valid JSON Web Token (JWT) is passed along with the request.        Sample Call      http://URL/api/User/GetTimeZones
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userGetTimeZones(observe?: 'body', reportProgress?: boolean): Observable<Array<UserTimeZone>>;
    public userGetTimeZones(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<UserTimeZone>>>;
    public userGetTimeZones(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<UserTimeZone>>>;
    public userGetTimeZones(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<UserTimeZone>>(`${this.basePath}/api/User/GetTimeZones`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Return the full name of the logged in user
     * This call only works if a valid JSON Web Token (JWT) is passed along with the request.        Sample Call      http://URL/api/User/GetUser
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userGetUser(observe?: 'body', reportProgress?: boolean): Observable<User>;
    public userGetUser(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<User>>;
    public userGetUser(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<User>>;
    public userGetUser(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/hal+json',
            'application/hal+xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<User>(`${this.basePath}/api/User/GetUser`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Return list of users in facility with lesser status
     * This call only works if a valid JSON Web Token (JWT) is passed along with the request.        Sample Call   http://URL/api/User/GetUserList?status&#x3D;A  ///
     * @param requestParameters 
     * @param status 
     * @param displayTimeZone 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userGetUserList(requestParameters: ApiRequestDto, status: string, displayTimeZone?: string, observe?: 'body', reportProgress?: boolean): Observable<PagedResultsAdminUserList>;
    public userGetUserList(requestParameters: ApiRequestDto, status: string, displayTimeZone?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PagedResultsAdminUserList>>;
    public userGetUserList(requestParameters: ApiRequestDto, status: string, displayTimeZone?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PagedResultsAdminUserList>>;
    public userGetUserList(requestParameters: ApiRequestDto, status: string, displayTimeZone?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling userGetUserList.');
        }

        if (status === null || status === undefined) {
            throw new Error('Required parameter status was null or undefined when calling userGetUserList.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (status !== undefined && status !== null) {
            queryParameters = queryParameters.set('status', <any>status);
        }
        if (displayTimeZone !== undefined && displayTimeZone !== null) {
            queryParameters = queryParameters.set('displayTimeZone', <any>displayTimeZone);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<PagedResultsAdminUserList>(`${this.basePath}/api/User/GetUserList`,
            requestParameters,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Return list of users in facility with lesser status with excel output
     * This call only works if a valid JSON Web Token (JWT) is passed along with the request.        Sample Call   http://URL/api/User/GetUserListWithExcel?status&#x3D;A
     * @param requestParameters 
     * @param status 
     * @param displayTimeZone 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userGetUserListWithExcel(requestParameters: ApiRequestDto, status: string, displayTimeZone?: string, observe?: 'body', reportProgress?: boolean): Observable<AdminUserListingResultAdminUserList>;
    public userGetUserListWithExcel(requestParameters: ApiRequestDto, status: string, displayTimeZone?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AdminUserListingResultAdminUserList>>;
    public userGetUserListWithExcel(requestParameters: ApiRequestDto, status: string, displayTimeZone?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AdminUserListingResultAdminUserList>>;
    public userGetUserListWithExcel(requestParameters: ApiRequestDto, status: string, displayTimeZone?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling userGetUserListWithExcel.');
        }

        if (status === null || status === undefined) {
            throw new Error('Required parameter status was null or undefined when calling userGetUserListWithExcel.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (status !== undefined && status !== null) {
            queryParameters = queryParameters.set('status', <any>status);
        }
        if (displayTimeZone !== undefined && displayTimeZone !== null) {
            queryParameters = queryParameters.set('displayTimeZone', <any>displayTimeZone);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<AdminUserListingResultAdminUserList>(`${this.basePath}/api/User/GetUserListWithExcel`,
            requestParameters,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns User information, facilities that he has been given access to   and Notification Settings
     * Pass userName as null or empty requesting for a new user  Pass in a valid user if requesting for editing user info and settings        Sample Call      http://URL/api/User/GetUserSettings?userName&#x3D;X
     * @param userName 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userGetUserSettings(userName?: string, observe?: 'body', reportProgress?: boolean): Observable<UserSettings>;
    public userGetUserSettings(userName?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserSettings>>;
    public userGetUserSettings(userName?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserSettings>>;
    public userGetUserSettings(userName?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (userName !== undefined && userName !== null) {
            queryParameters = queryParameters.set('userName', <any>userName);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/hal+json',
            'application/hal+xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<UserSettings>(`${this.basePath}/api/User/GetUserSettings`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns User information, facilities that he has been given access to   and Notification Settings when a user edits the user&#39;s own profile.
     * Sample Call  http://URL/api/User/GetUserSettingsForNotificationsEdit
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userGetUserSettingsForNotificationsEdit(observe?: 'body', reportProgress?: boolean): Observable<UserSettings>;
    public userGetUserSettingsForNotificationsEdit(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserSettings>>;
    public userGetUserSettingsForNotificationsEdit(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserSettings>>;
    public userGetUserSettingsForNotificationsEdit(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/hal+json',
            'application/hal+xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<UserSettings>(`${this.basePath}/api/User/GetUserSettingsForNotificationsEdit`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns User Profile Information
     * Sample Call  http://URL/api/User/GetUserSettingsForProfileEdit
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userGetUserSettingsForProfileEdit(observe?: 'body', reportProgress?: boolean): Observable<UserSettings>;
    public userGetUserSettingsForProfileEdit(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserSettings>>;
    public userGetUserSettingsForProfileEdit(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserSettings>>;
    public userGetUserSettingsForProfileEdit(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/hal+json',
            'application/hal+xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<UserSettings>(`${this.basePath}/api/User/GetUserSettingsForProfileEdit`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns the allowed units for a given user.  Allowed units can be a facility and regions
     * Sample Call  https://URL/MyRemediV3/api/User/GetUserUnits?username&#x3D;TestUserUPro
     * @param username Username of current user (Optional, for use only during initial UI build)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userGetUserUnits(username?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<OrgUnitModel>>;
    public userGetUserUnits(username?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<OrgUnitModel>>>;
    public userGetUserUnits(username?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<OrgUnitModel>>>;
    public userGetUserUnits(username?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (username !== undefined && username !== null) {
            queryParameters = queryParameters.set('username', <any>username);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<OrgUnitModel>>(`${this.basePath}/api/User/GetUserUnits`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userIsPasswordExpired(observe?: 'body', reportProgress?: boolean): Observable<string>;
    public userIsPasswordExpired(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public userIsPasswordExpired(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public userIsPasswordExpired(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.post<string>(`${this.basePath}/api/User/CheckPasswordExpired`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Reset password for the user.  Used when a New user is created and user has to   create a new password for the first time that he  logs in.
     * This call takes in password string that has been encrypted from UI.         Sample Call      http://URL/api/User/ResetPassword?newPassword&#x3D;pgyawali
     * @param username New Password entered by the User. Encrypted by UI
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userResetPassword(username: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public userResetPassword(username: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public userResetPassword(username: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public userResetPassword(username: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (username === null || username === undefined) {
            throw new Error('Required parameter username was null or undefined when calling userResetPassword.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (username !== undefined && username !== null) {
            queryParameters = queryParameters.set('username', <any>username);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.post<string>(`${this.basePath}/api/User/ResetPassword`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param phoneNumber 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userSendPhoneCode(phoneNumber: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public userSendPhoneCode(phoneNumber: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public userSendPhoneCode(phoneNumber: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public userSendPhoneCode(phoneNumber: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (phoneNumber === null || phoneNumber === undefined) {
            throw new Error('Required parameter phoneNumber was null or undefined when calling userSendPhoneCode.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<string>(`${this.basePath}/api/User/SendPhoneCode`,
            phoneNumber,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param code 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userValidateCode(code: string, observe?: 'body', reportProgress?: boolean): Observable<APISubmitResult>;
    public userValidateCode(code: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<APISubmitResult>>;
    public userValidateCode(code: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<APISubmitResult>>;
    public userValidateCode(code: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (code === null || code === undefined) {
            throw new Error('Required parameter code was null or undefined when calling userValidateCode.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<APISubmitResult>(`${this.basePath}/api/User/ValidateCode`,
            code,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
